export default {
  namespaced: true,
  state: {
    SiteName: '',
    SiteAddress: '',
    ConfirmationNumber: '',
    FormattedCheckinDateTime: '',
    BookingDateTime: '',
    BookingDuration: '',
    SiteId: '',
    SendSms: '',
    SlotId: '',
    RescheduleBooking: false,
    ServiceType: '',
    ServiceTypeText: '',
    ServiceTypeId: '',
    NewAppointmentSelected: false,
  },
  mutations: {
    siteName(state, payload) {
      state.SiteName = payload.value;
    },
    siteAddress(state, payload) {
      state.SiteAddress = payload.value;
    },
    confirmationNumber(state, payload) {
      state.ConfirmationNumber = payload.value;
    },
    formattedCheckinDateTime(state, payload) {
      state.FormattedCheckinDateTime = payload.value;
    },
    bookingDateTime(state, payload) {
      state.BookingDateTime = payload.value;
    },
    bookingDuration(state, payload) {
      state.BookingDuration = payload.value;
    },
    siteId(state, payload) {
      state.SiteId = payload.value;
    },
    sendSms(state, payload) {
      state.SendSms = payload.value;
    },
    slotId(state, payload) {
      state.SlotId = payload.value;
    },
    rescheduleBooking(state, payload) {
      state.RescheduleBooking = payload.value;
    },
    serviceType(state, payload) {
      state.ServiceType = payload.value;
    },
    serviceTypeText(state, payload) {
      state.ServiceTypeText = payload.value;
    },
    serviceTypeId(state, payload) {
      state.ServiceTypeId = payload.value;
    },
    newAppointmentSelected(state, payload) {
      state.NewAppointmentSelected = payload.value;
    },
  },
  actions: {
    siteName(context, payload) {
      context.commit('siteName', payload);
    },
    siteAddress(context, payload) {
      context.commit('siteAddress', payload);
    },
    confirmationNumber(context, payload) {
      context.commit('confirmationNumber', payload);
    },
    formattedCheckinDateTime(context, payload) {
      context.commit('formattedCheckinDateTime', payload);
    },
    bookingDateTime(context, payload) {
      context.commit('bookingDateTime', payload);
    },
    bookingDuration(context, payload) {
      context.commit('bookingDuration', payload);
    },
    siteId(context, payload) {
      context.commit('siteId', payload);
    },
    sendSms(context, payload) {
      context.commit('sendSms', payload);
    },
    slotId(context, payload) {
      context.commit('slotId', payload);
    },
    rescheduleBooking(context, payload) {
      context.commit('rescheduleBooking', payload);
    },
    serviceType(context, payload) {
      context.commit('serviceType', payload);
    },
    serviceTypeText(context, payload) {
      context.commit('serviceTypeText', payload);
    },
    serviceTypeId(context, payload) {
      context.commit('serviceTypeId', payload);
    },
    newAppointmentSelected(context, payload) {
      context.commit('newAppointmentSelected', payload);
    },
  },
  getters: {
    siteName(state) {
      return state.SiteName;
    },
    siteAddress(state) {
      return state.SiteAddress;
    },
    confirmationNumber(state) {
      return state.ConfirmationNumber;
    },
    formattedCheckinDateTime(state) {
      return state.FormattedCheckinDateTime;
    },
    bookingDateTime(state) {
      return state.BookingDateTime;
    },
    bookingDuration(state) {
      return state.BookingDuration;
    },
    siteId(state) {
      return state.SiteId;
    },
    sendSms(state) {
      return state.SendSms;
    },
    slotId(state) {
      return state.SlotId;
    },
    rescheduleBooking(state) {
      return state.RescheduleBooking;
    },
    serviceType(state) {
      return state.ServiceType;
    },
    serviceTypeText(state) {
      return state.ServiceTypeText;
    },
    serviceTypeId(state) {
      return state.ServiceTypeId;
    },
    newAppointmentSelected(state) {
      return state.NewAppointmentSelected;
    },
  },
};
